import React from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import PropTypes from "prop-types";
import "./popularPostItem.scss";
import { getBlogPostUri } from "../../../utils/buzzHelper";
import FallBackImg from "../../FallBackImg/fallBackImg";
import {
  POPULAR_POST_IMG_FALLBACK_ALT,
  POPULAR_POST_IMG_FALLBACK,
} from "./popularPostItem.constants";
import {
  getImgUrl,
  IMG_VARIANTS,
} from "../../../constants/imgVariants";

const PopularPostItem = ({
  post,
  index,
  handleLinkClick,
}) => {
  if (!post) {
    return null;
  }
  const {
    uri,
    title,
    date,
    featuredImage,
    categories,
    seo: { readingTime },
    slug,
  } = post;

  const popularPostImgUrl = getImgUrl(
    slug,
    IMG_VARIANTS.MOST_POPULAR
  );

  const fluidImage =
    featuredImage?.node?.localFile?.childImageSharp?.fluid;

  const getPostDetails = () => {
    return (
      <div className="post-details">
        {readingTime && (
          <>
            <span>{readingTime} min read</span>
            <span>.</span>
          </>
        )}
        <span>{date}</span>
      </div>
    );
  };

  return (
    <Link
      to={getBlogPostUri(post)}
      onClick={() => handleLinkClick(title)}
      itemProp="url"
    >
      <div className="popular-post-item">
        <div className="popular-post-image">
          {fluidImage ? (
            <FallBackImg
              fallbackImg={popularPostImgUrl}
              fallbackImgAlt={title}
            />
          ) : (
            <FallBackImg
              fallbackImg={POPULAR_POST_IMG_FALLBACK}
              fallbackImgAlt={POPULAR_POST_IMG_FALLBACK_ALT}
            />
          )}

          <div className="image-index rajdhani-font">
            {index + 1}
          </div>
        </div>

        <div className="popular-post-content">
          <div className="post-categories rajdhani-font">
            {categories?.nodes?.map(category => {
              return (
                <div
                  className="post-category"
                  key={category?.id}
                >
                  {category?.name}
                </div>
              );
            })}
          </div>
          <div className="post-title">{title}</div>
          {getPostDetails()}
        </div>
      </div>
    </Link>
  );
};

PopularPostItem.propTypes = {
  post: PropTypes.object,
  index: PropTypes.number,
};

export default PopularPostItem;
